import type { ExtendedLocationSuggestOption } from './model/constants/filterTypes';

export const CUSTOMER_RECENT_SEARCHES_KEY = 'customer-homepage-recent-searches';

type RecentSearches = {
  queries?: ExtendedLocationSuggestOption[];
};

export const getCustomerRecentLocations = (): ExtendedLocationSuggestOption[] => {
  try {
    const { queries } = JSON.parse(
      localStorage.getItem(CUSTOMER_RECENT_SEARCHES_KEY) ?? '',
    ) as RecentSearches;
    return (
      queries?.map((query) => ({
        ...query,
        type: 'recent',
      })) ?? []
    );
  } catch (e) {
    return [];
  }
};

export const getCustomerMostRecentLocation = (): ExtendedLocationSuggestOption[] => {
  const queries = getCustomerRecentLocations();
  return queries && queries.length > 0 ? [queries[0]] : [];
};

export const setCustomerRecentLocations = (query: ExtendedLocationSuggestOption) => {
  const recentSearchesItem = localStorage.getItem(CUSTOMER_RECENT_SEARCHES_KEY);
  const recentSearches = recentSearchesItem && (JSON.parse(recentSearchesItem) as RecentSearches);
  const queries: ExtendedLocationSuggestOption[] =
    recentSearches && recentSearches.queries ? recentSearches.queries : [];
  localStorage.setItem(
    CUSTOMER_RECENT_SEARCHES_KEY,
    JSON.stringify({
      queries: [query, ...queries]
        .filter((item, i, arr) => arr.findIndex((t) => t.display.text === item.display.text) === i)
        .slice(0, 5),
    }),
  );
};
